import { cx } from '@libs/classnames';

import { IPoolInfoDto, IPoolType } from '@features/game/types/fast-game';

import styles from './PairingSearch.module.css';

/*
    ____,-------------------------------,____
    \   |           Component           |   /
    /___|-------------------------------|___\
*/

interface ITimeControlOption {
  pool: IPoolType;
  label: string;
  typeLabel: string;
}

const TIME_CONTROLS: ITimeControlOption[] = [
  { pool: 'Bullet1Plus0', label: '1+0', typeLabel: 'Пуля' },
  { pool: 'Blitz3Plus0', label: '3+0', typeLabel: 'Блиц' },
  { pool: 'Blitz3Plus2', label: '3+2', typeLabel: 'Блиц' },
  { pool: 'Blitz5Plus0', label: '5+0', typeLabel: 'Блиц' },
  { pool: 'Blitz5Plus3', label: '5+3', typeLabel: 'Блиц' },
  { pool: 'Rapid10Plus0', label: '10+0', typeLabel: 'Рапид' },
  { pool: 'Rapid10Plus5', label: '10+5', typeLabel: 'Рапид' },
];

type Props = {
  className?: string;
  selectedPools: IPoolType[];
  poolStats: IPoolInfoDto[];
  isAuthenticated: boolean;
  onPoolsChange: (pools: IPoolType[]) => void;
};

export function PairingSearch({
  className,
  selectedPools,
  poolStats,
  isAuthenticated,
  onPoolsChange,
}: Props) {
  const handleToggle = (pool: IPoolType) => {
    const isSelected = selectedPools.includes(pool);
    if (isSelected) {
      onPoolsChange(selectedPools.filter((p) => p !== pool));
    } else {
      onPoolsChange([...selectedPools, pool]);
    }
  };

  return (
    <section className={cx(className, styles.fast_game_search)}>
      <div className={styles.time_control_hint}>
        <p>Выберите один или несколько режимов</p>
      </div>
      {TIME_CONTROLS.map((tc) => {
        const isSelected = selectedPools.includes(tc.pool);
        const poolInfo = poolStats.find((p) => p.pool === tc.pool);
        const count = poolInfo?.players ?? 0;

        return (
          <button
            key={tc.pool}
            className={cx(styles.time_control_button, {
              [styles.is_selected]: isSelected,
            })}
            onClick={() => handleToggle(tc.pool)}
            type="button"
          >
            <div className={styles.time_control__top}>
              <span className={styles.time_control_type}>{tc.typeLabel}</span>
              <span className={styles.time_control_count}>{isSelected ? count || 1 : count}</span>
            </div>
            <span className={styles.time_control_label}>{tc.label}</span>
          </button>
        );
      })}
      <div className={styles.time_control_hint}>
        {isAuthenticated ? (
          <p>Результат игры будет отражен в рейтинге</p>
        ) : (
          <p>Войдите, чтобы игры отражались в рейтинге</p>
        )}
      </div>
    </section>
  );
}
